import React from "react";
import { Navigate } from "react-router-dom";
import { useAdmin } from "./AdminContext";

const ProtectedAdminRoute = ({ children }: { children: JSX.Element }) => {
  const { isAdmin, loading } = useAdmin();

  if (loading) return <div>Chargement des droits...</div>;

  if (!isAdmin) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedAdminRoute;
